module.exports = __webpack_public_path__ + "media/images/icons/icon-carousel-prev-e97c7723981ee8fab8d81b9a61a81fe6.svg";